import { render, staticRenderFns } from "./TwitterBlack.vue?vue&type=template&id=dfb013c4&scoped=true&"
import script from "./TwitterBlack.vue?vue&type=script&lang=js&"
export * from "./TwitterBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb013c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb013c4')) {
      api.createRecord('dfb013c4', component.options)
    } else {
      api.reload('dfb013c4', component.options)
    }
    module.hot.accept("./TwitterBlack.vue?vue&type=template&id=dfb013c4&scoped=true&", function () {
      api.rerender('dfb013c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/TwitterBlack.vue"
export default component.exports